/**
 * 新建发票登记 表单配置处理
 * @author zjs
 * @time 2018-03-13
 */
let vm = {
    data () {
        return {
            // 表单组件配置
            formConfig: [{
                name: "开票日期",
                type: "LyDatePicker",
                field: "work_time",
                json: {
                    type: 'date'
                },
                default: ""
            },{
                name: "客户名称",
                type: "LyAutoSearch",
                field: "customer",
                width: '220px',
                json: {
                    width: '661px',
                    api: 'api/customer',
                    prop: 'customer_name',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 90
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }, {
                        label: '联系人',
                        prop: 'customer_contact',
                        width: 160
                    }, {
                        label: '联系电话',
                        prop: 'customer_tel',
                        width: 140
                    }]
                },
                default: {}
            },{
                name: "客户编码",
                type: "LyAutoSearch",
                field: "customer",
                width: '220px',
                json: {
                    width: '661px',
                    api: 'api/customer',
                    prop: 'customer_account',
                    fields: [{
                        label: '客户编码',
                        prop: 'customer_account',
                        width: 90
                    }, {
                        label: '客户名称',
                        prop: 'customer_name',
                        width: 270
                    }, {
                        label: '联系人',
                        prop: 'customer_contact',
                        width: 160
                    }, {
                        label: '联系电话',
                        prop: 'customer_tel',
                        width: 140
                    }]
                },
                default: {}
            },{
                name: "联系人",
                type: "ElInput",
                field: "customer",
                width: '220px',
                json: {
                    prop: 'customer_contact'
                },
                default: {}
            },{
                name: "上月销售金额",
                type: "LyQueryInput",
                field: "sale_all_amount",
                json: {
                    disabled: true,
                    api: 'api/getCustomerSaleMoney',
                    filed: 'sale_all_amount',
                    watch: 'customer'
                },
                default: ""
            },{
                name: "本月开票金额",
                type: "LyQueryInput",
                field: "invoice_all_amount",
                json: {
                    disabled: true,
                    api: 'api/getCustomerInvoiceMoney',
                    filed: 'invoice_all_amount',
                    watch: 'customer'
                },
                default: ""
            },{
                name: "业务团队",
                type: "LySelect",
                field: "business_team_id",
                json: {
                    all: false,
                    api: 'api/businessteam',
                    defOne: true
                },
                default: ""
            },{
                name: "业务员",
                type: "LySelect",
                field: "employee_id",
                json: {
                    all: false,
                    api: 'api/employee'
                },
                default: ''
            }, {
                name: "发票类型",
                type: "LySelect",
                field: "invoice_type",
                json: { 
                    all: false,
                    data: [{
                        value: '1',
                        label: '增专票'
                    }, {
                        value: '2',
                        label: '普票'
                    }]
                },
                default: "1"
            },
            /* ------- 第37批调整需求，不从客户信息中带单位出来，直接通过搜索组件出来 start----- */
            // {
            //     name: "开票单位",
            //     type: "LyAutoSelect",
            //     field: "invoice_unit_name",
            //     width: '1005px',
            //     json: {
            //         span: 24,
            //         api: 'api/getinvoiceunit',
            //         realSearch: false,
            //         watch: 'customer'
            //     },
            //     default: ''
            // },
            /* ------- 第37批调整需求，不从客户信息中带单位出来，直接通过搜索组件出来 end----- */
             {
                name: "开票单位",
                type: "LyAutoSearch",
                field: "invoice",
                width: '1005px',
                json: {
                    span: 24,
                    width: '1005px',
                    api: 'api/kehukp',
                    prop: 'invoice_unit_name',
                    fields: [{
                        label: '开票单位',
                        prop: 'invoice_unit_name'
                    }, {
                        label: '纳税人识别码',
                        prop: 'taxpayer_mark'
                    }, {
                        label: '地址电话',
                        prop: 'address_phone'
                    }, {
                        label: '开户行，账号',
                        prop: 'open_bank_account'
                    }],
                    isWatchOther: true,
                    other: 'customer'
                },
                default: {}
            },
            {
                name: "纳税人识别号",
                type: "LyAutoSearch",
                field: "invoice",
                width: '1005px',
                placeholder: '请输入纳税人识别号（必填）',
                json: {
                    span: 24,
                    width: '1005px',
                    api: 'api/kehukp',
                    prop: 'taxpayer_mark',
                    fields: [{
                        label: '开票单位',
                        prop: 'invoice_unit_name'
                    }, {
                        label: '纳税人识别码',
                        prop: 'taxpayer_mark'
                    }, {
                        label: '地址电话',
                        prop: 'address_phone'
                    }, {
                        label: '开户行，账号',
                        prop: 'open_bank_account'
                    }],
                    other: 'customer'
                },
                default: {}
            },{
                name: "地址、电话",
                type: "ElInput",
                field: "invoice",
                width: '1005px',
                placeholder: '请输入地址、电话（增专票必填）',
                json: {
                    span: 24,
                    prop: 'address_phone'
                },
                default: {}
            },{
                name: "开户行及账号",
                type: "ElInput",
                field: "invoice",
                width: '1005px',
                placeholder: '请输入开户行、账号（增专票必填）',
                json: {
                    span: 24,
                    prop: 'open_bank_account'
                },
                default: {}
            },{
                name: "说明",
                type: "ElInput",
                field: "zhaiyao",
                width: '1005px',
                placeholder: '请输入说明，请勿用非中英文文字作为开头',
                json: {
                    span: 24
                },
                default: ""
            },{
                name: "剩余开票金额",
                type: "text",
                field: "sykpje",
                width: '1005px',
                json: {
                    span: 24
                },
                default: ""
            }, { // 配置一个函数，用于指令的调用］
                type: 'function',
                func (formdata, callback) {
                    // 选择客户后，将客户中的业务员 加入到业务员对象中
                    if (formdata.customer.employee_id && formdata.customer.employee_id !== vm.lastEmployee_id) {
                        vm.lastEmployee_id = formdata.customer.employee_id
                        formdata.employee_id = formdata.customer.employee_id
                        formdata.sykpje = (parseFloat(formdata.sale_all_amount) - parseFloat(formdata.invoice_all_amount)) || 0
                        formdata.invoice_type = formdata.customer.invoice_type || 1
                    }
                    // callback 必须要有 by welpher 2022-1-17
                    if (typeof callback === 'function') callback()
                }
            }]
        }
    },
    /**
     * 组件离场时调用，用于清空缓存数据
     * @return {[type]} [description]
     */
    clear () {
        vm.lastEmployee_id = null
    }
}

export default vm